import React from 'react'

type TFotoBodyProgressProps = {
  fotoBodyBlock: {
    title: string
    period?: string
    name?: string
    weight?: string
    description?: string
  }
  foto: HTMLImageElement
}

export const FotoBodyProgress = ({ fotoBodyBlock, foto }: TFotoBodyProgressProps) => {
  return (
    <>
      <div className="main-container">
        <div className="title" dangerouslySetInnerHTML={{ __html: fotoBodyBlock.title }}></div>
        <div className="img-container">
          <img src={foto.src} alt="guarantee" />
          {fotoBodyBlock.period && <div className="period">{fotoBodyBlock.period}</div>}
        </div>
        {fotoBodyBlock.name && fotoBodyBlock.weight && (
          <div className="data-model">
            <div className="model-name">{fotoBodyBlock.name}</div>
            <div className="burning-fat">{fotoBodyBlock.weight}</div>
          </div>
        )}
      </div>
      {fotoBodyBlock.description && (
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: fotoBodyBlock.description }}
        ></div>
      )}
    </>
  )
}
